import { DG_STORE_CONFIG, DG_WHATSAPP_CONFIG, buildWhatsAppUrl } from '@dg-embalajes/commerce';
import { Cloud, ExternalLink, FolderOpen, HelpCircle, Info, LogIn, MessageCircle, Plus, Smartphone } from 'lucide-react';
import { useState } from 'react';
import { APP_BUILD_ENVIRONMENT, APP_BUILD_ID, APP_VERSION } from '@/content/copy';
import type { AccountSnapshot } from '@/ports/account';
import type { EditorSnapshot } from '@/ports/editor';
import { Modal } from '../Modal';

interface AppMenuProps {
  readonly editor: EditorSnapshot;
  readonly account: AccountSnapshot;
  readonly onClose: () => void;
  readonly onProjects: () => void;
  readonly onCloudSave: () => void;
  readonly onAccount: () => void;
  readonly onPwa: () => void;
  readonly onNewProject: () => void;
}

export function AppMenu({ editor, account, onClose, onProjects, onCloudSave, onAccount, onPwa, onNewProject }: AppMenuProps) {
  const [showHelp, setShowHelp] = useState(false);
  return (
    <Modal title="DG embalajes" size="small" onClose={onClose}>
      <div className="menu-project-state">
        <strong>{editor.projectName}</strong>
        <span>{editor.saveStatus === 'saved' ? 'Guardado en este dispositivo' : editor.saveStatus === 'saving' ? 'Guardando...' : 'Borrador local'}</span>
      </div>
      <nav className="app-menu-list" aria-label="Acciones de aplicación">
        <button type="button" onClick={onProjects}><FolderOpen /> <span><strong>Mis proyectos</strong><small>Abrir, renombrar, duplicar o eliminar</small></span></button>
        <button type="button" onClick={onCloudSave}><Cloud /> <span><strong>Guardar en la nube</strong><small>Sincronizar y recuperar en otro dispositivo</small></span></button>
        <button type="button" onClick={onAccount}><LogIn /> <span><strong>{account.status === 'authenticated' ? 'Tu cuenta' : 'Iniciar sesión'}</strong><small>{account.email ?? 'Email y contraseña'}</small></span></button>
        <a href={DG_STORE_CONFIG.url} target="_blank" rel="noreferrer"><ExternalLink /> <span><strong>Ver precios y medidas</strong><small>La tienda se abre sin borrar el proyecto</small></span></a>
        <a href={buildWhatsAppUrl(DG_WHATSAPP_CONFIG.messages.general)} target="_blank" rel="noreferrer"><MessageCircle /> <span><strong>WhatsApp DG embalajes</strong><small>11 5879-6618</small></span></a>
        <button type="button" onClick={onPwa}><Smartphone /> <span><strong>Instalar aplicación</strong><small>Disponible después de usar el editor</small></span></button>
        <button type="button" aria-expanded={showHelp} onClick={() => setShowHelp((value) => !value)}><HelpCircle /> <span><strong>Ayuda contextual</strong><small>Mesa, objetos, ALTO y DESARROLLO</small></span></button>
        <button type="button" onClick={onNewProject}><Plus /> <span><strong>Nuevo diseño</strong><small>El borrador actual queda guardado</small></span></button>
      </nav>
      {showHelp ? (
        <div className="menu-help" role="status">
          <p><strong>Mesa:</strong> un dedo mueve la vista; dos dedos acercan y rotan la cámara.</p>
          <p><strong>Elemento:</strong> al tocar texto o imagen, los gestos actúan sólo sobre ese objeto.</p>
          <p><strong>ALTO:</strong> altura del envase. <strong>DESARROLLO:</strong> vuelta alrededor del tubo.</p>
        </div>
      ) : null}
      <details className="diagnostic-details" data-testid="build-diagnostics">
        <summary><Info /> Información / Diagnóstico</summary>
        <dl>
          <div><dt>Versión</dt><dd>{APP_VERSION}</dd></div>
          <div><dt>Build</dt><dd data-testid="build-id">{APP_BUILD_ID}</dd></div>
          <div><dt>Ambiente</dt><dd>{APP_BUILD_ENVIRONMENT}</dd></div>
          <div><dt>Runtime</dt><dd>integrated</dd></div>
          <div><dt>Licencias</dt><dd>/licenses/THIRD_PARTY_NOTICES.txt</dd></div>
        </dl>
      </details>
    </Modal>
  );
}
